import { useEffect, useRef } from 'react';

/**
 * Layered Escape handling: the most recently activated handler wins (dialog over lightbox over selection),
 * matching the prototype's priorities.
 */
const stack: { current: () => void }[] = [];
let listening = false;

function onKey(e: KeyboardEvent) {
  if (e.key !== 'Escape' || e.defaultPrevented) return;
  const top = stack[stack.length - 1];
  if (top) {
    e.preventDefault();
    top.current();
  }
}

export function useEscape(handler: () => void, active = true) {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    if (!active) return;
    if (!listening) {
      window.addEventListener('keydown', onKey);
      listening = true;
    }
    const entry = { current: () => ref.current() };
    stack.push(entry);
    return () => {
      const i = stack.indexOf(entry);
      if (i !== -1) stack.splice(i, 1);
    };
  }, [active]);
}
